export default __webpack_public_path__ + "images/2182fe0d39f3715e388dcddd47bf739d.png";